<template>
  <div
    ref="openEndedOneByOne"
    class="one-by-one horizontal layout center center-justified"
  >
    <transition :name="animationName">
      <div
        class="open-ended-title vertical layout"
        :class="{'has-audience-info': optionActive.audienceName ||
          optionActive.audienceTeam || optionActive.audienceEmoji
          || optionActive.audienceEmail
        }"
        v-if="show && optionActive.id"
        :style="{ boxShadow: setBoxShadowValue(optionActive, optionActive.indexOption),
                  'background-color': _openEndedBg() }"
      >
        <div
          class="title-text horizontal layout"
          :class="{'has-image-submission': slideActive.imageSubmission && optionActive.image,
                   'image-spacing': !optionActive.title && optionActive.image}"
        >
          <div class="scroll-wrapper">
            <ui-pre-line :text="optionActive.title" />
            <ButtonEnlargeImage
              :image="optionActive.image"
              :noContent="!optionActive.title && !slideActive.imageSubmission"
              class="content-image"
              :class="{'mt-0': !optionActive.title && optionActive.image}"
              v-show="isImageSubmissionVisible && optionActive.image"
            />
            <aha-icon
              name="image"
              class="text-secondary-20"
              width="35"
              height="35"
              viewBox="0 0 24 24"
              v-if="!slideActive.imageSubmission && !optionActive.title"
            />
          </div>
        </div>
        <div
          class="audience-info"
          :class="{'dark': slideActive.textColour == '#ffffff'}"
          v-show="_checkShowAudienceInfo(optionActive)"
        >
          <span
            class="info--emoji"
            v-if="_checkShowAudienceFields('avatar', optionActive.audienceEmoji)"
          >
            {{ optionActive.audienceEmoji }}
          </span>
          <span
            class="info--name"
            v-if="_checkShowAudienceFields('name', optionActive.audienceName)"
          >
            <profanity-filter :text="optionActive.audienceName" />
          </span>
          <div>
            <p
              class="info--other-team"
              v-if="_checkShowAudienceFields('team', optionActive.audienceTeam)"
            >
              <profanity-filter :text="optionActive.audienceTeam" />
            </p>
            <p
              class="info--other-email"
              v-if="_checkShowAudienceFields('email', optionActive.audienceEmail)"
            >
              <profanity-filter :text="optionActive.audienceEmail" />
            </p>
          </div>
        </div>
        <span
          class="ml-2 mr-1 remove-icon"
          @click.stop="$emit('removeResponse', optionActive,optionActive.indexOption)"
          v-if="!$store.state.sharePresentation && !isBackstage"
          :class="{'alway-show': optionActiveDeleting}"
        >
          <b-button v-tooltip="'Remove this response'" class="tooltip-btn" />
          <i class="fas fa-times-circle" v-if="!optionActiveDeleting" />
          <span
            class="loading-spinner"
            v-if="optionActiveDeleting"
            :class="{'black': slideActive.textColour === '#313131'}"
          />
        </span>
      </div>
    </transition>

    <div
      class="arrow-top"
      @click="$emit('backOption')"
      v-if="slideActive.openededCount && optionActive.indexOption"
    >
      <i class="fas fa-chevron-up" />
    </div>
    <div
      class="arrow-bottom"
      @click="$emit('nextOption')"
      v-if="slideActive.openededCount &&
        optionActive.indexOption != slideActive.openededCount - 1"
    >
      <i class="fas fa-chevron-down" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import utils from '@/util'
import PreLine from '@/components/UI/PreLine.vue'
import ButtonEnlargeImage from '@/components-v2/presentation-editor/middle/ButtonEnlargeImage.vue'
import ProfanityFilter from '@/components-v2/common/utils/ProfanityFilter.vue'

export default {
  components: {
    UiPreLine: PreLine,
    ButtonEnlargeImage,
    ProfanityFilter,
  },
  props: {
    optionActive: {
      type: Object,
      default: () => {},
    },
    optionActiveDeleting: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
    animationName: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    ...mapGetters(['isBackstage']),
    isImageSubmissionVisible() {
      return this.slideActive.imageSubmission &&
        this.slideActive.type === 'openEnded'
    },
  },
  methods: {
    _checkShowAudienceInfo(answer) {
      return utils.checkShowAudienceInfo(answer)
    },

    _checkShowAudienceFields(fieldName, audienceInfo) {
      return utils.checkShowAudienceFields(fieldName, audienceInfo)
    },

    setBoxShadowValue(item, index) {
      return `0 0 0 1.5px ${utils.setToColorPalette(item, index)}`
    },

    _openEndedBg(text) {
      if (this.slideActive.layout == 'oneByOne') {
        if (this.slideActive.textColour == '#313131') {
          return 'rgba(255, 255, 255, 0.75)'
        }
        return 'rgba(255, 255, 255, 0.08)'
      }
      if (text) {
        return this.slideActive.baseColour
      }
      const color = utils.hexToRgba(this.slideActive.baseColour)
      return utils.changeRgbaColor(color, 0.6)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.one-by-one {
  width: 100%;
  height: 100%;
  position: relative;
  font-size: 25px;
  padding: 0 20px;

  .open-ended-title {
    padding: 30px 40px;
    border-radius: 20px;
    max-width: 76%;
    max-height: 460px;
    word-break: break-word;
    box-shadow: 10px 10px 16px rgba(0, 0, 0, 0.075);
    position: relative;
    overflow: hidden;

    .audience-info {
      .info--name {
        font-size: 25px;
        font-weight: bold;
      }
    }

    .title-text {
      padding: 15px 0;
      margin-top: 0;
      overflow: hidden;
      font-size: 34px;
      &.has-image-submission {
      max-height: 370px;
    }

      .scroll-wrapper {
        overflow-y: auto;
        max-height: 100%;
        padding: 0 25px;
        width: 100%;
      }
    }

    .remove-icon {
      opacity: 0;
      right: 15px;
      .tooltip-btn {
        top: 4px;
        padding: 0.9rem;
      }

      &.alway-show {
        opacity: 1;
      }
    }
    &:hover {
      .remove-icon {
        opacity: 0.5;
        &:hover {
          opacity: 1;
        }
      }
    }
  }

  .arrow-top {
    position: absolute;
    width: 150px;
    height: 50px;
    left: 50%;
    margin-left: -75px;
    text-align: center;
    top: 0;
    line-height: 50px;
    cursor: pointer;
    font-size: 25px;

    &:hover {
      color: #666;
    }
  }
  .arrow-bottom {
    position: absolute;
    width: 150px;
    height: 50px;
    left: 50%;
    margin-left: -75px;
    text-align: center;
    bottom: 0;
    line-height: 50px;
    font-size: 25px;

    cursor: pointer;
    &:hover {
      color: #666;
    }
  }
}

.has-audience-info {
  .info--other-team, .info--other-email {
    font-size: 0.85em;
  }
  &.body-content {
    padding: 0!important;
    .content-title {
      padding: 12px 16px;
      @apply w-full;
    }
    .audience-info {
      padding: 7px 16px;
      line-height: 1.2;
      .info--emoji {
        min-width: 38px;
        font-size: 28px;
      }
    }
  }
  &.open-ended-title {
    padding: 0 !important;
    -webkit-overflow-scrolling: touch; //Chrome
    -ms-overflow-style: none; //IE, edge
    overflow: -moz-scrollbars-none; //Firefox
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    .title-text {
      padding: 0 30px 25px;
      max-height: 150px;
      min-height: 75px;
      overflow-y: auto;
      margin-top: 25px;
    }
    .audience-info {
      padding: 12px 30px;
      line-height: 1.2;
      .info--emoji {
        min-width: 35px;
        font-size: 30px;
        display: inline-block;
      }
    }
  }
}

.remove-icon {
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 0.2rem;
  opacity: 0;
  height: 20px;
  .fa-times-circle {
    color: $question-tooltips-color;
  }
  .tooltip-btn {
    position: absolute;
    padding: 0.55rem;
    opacity: 0;
    top: 1.5px;
  }

  &.alway-show {
    opacity: 1;
  }
}
</style>
